import * as Yup from 'yup';

import { Filters, RUBRIC_TYPES } from '../../Datatable.types';
import messages from '../messages';

// ici recevoir valeurMin et valeurMax et les comparer
const testRangeFilter = (values: {
  filterStartRangeNumeric?: number;
  filterEndRangeNumeric?: number;
}) => {
  const { filterStartRangeNumeric, filterEndRangeNumeric } = values;

  if (
    filterStartRangeNumeric !== undefined &&
    filterEndRangeNumeric !== undefined &&
    filterStartRangeNumeric > filterEndRangeNumeric
  ) {
    return false;
  }

  return true;
};

export const createFiltersRangeSchema = (filters?: Filters) => {
  const schema: any = {};

  filters?.forEach((filter) => {
    if (
      filter.type === RUBRIC_TYPES.RANGE_NUMERIC ||
      filter.type === RUBRIC_TYPES.PERCENTAGE
    ) {
      const startKey = `filterStartRangeNumeric_${filter.name}`;
      const endKey = `filterEndRangeNumeric_${filter.name}`;

      schema[startKey] = Yup.number().test(
        startKey,
        messages.maxMustBeMoreThanMin,
        function test(_, context: any) {
          return testRangeFilter({
            filterStartRangeNumeric: context.from[0].value[startKey],
            filterEndRangeNumeric: context.from[0].value[endKey],
          });
        },
      );

      schema[endKey] = Yup.number().test(
        endKey,
        messages.maxMustBeMoreThanMin,
        function test(_, context: any) {
          return testRangeFilter({
            filterStartRangeNumeric: context.from[0].value[startKey],
            filterEndRangeNumeric: context.from[0].value[endKey],
          });
        },
      );
    }
  });

  return Yup.object().shape(schema);
};
